import { render, staticRenderFns } from "./suggested-response-template.vue?vue&type=template&id=7c8eb5b6&scoped=true&"
import script from "./suggested-response-template.vue?vue&type=script&lang=js&"
export * from "./suggested-response-template.vue?vue&type=script&lang=js&"
import style0 from "./suggested-response-template.vue?vue&type=style&index=0&id=7c8eb5b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8eb5b6",
  null
  
)

export default component.exports